import React, { useEffect, useState } from 'react'
import BigModal from '../../../../../components/Modals/BigModal'
import { Alert, Button, Stack, Typography } from '@mui/material'
import API from '../../../../../services/API'
import DetailsBox, {
  DetailRow,
} from '../../../../../components/Cards/DetailsBox'
import moment from 'moment'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'

const SingleDrivingLicenceCheck = ({ checkID, onClose }) => {
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [check, setcheck] = useState({})
  const [attachment, setAttachment] = useState('')

  useEffect(() => {
    if (checkID) {
      API.get('/employees/single-driving-licence-check/' + checkID)
        .then((res) =>
          res.status === 200 ? setcheck(res.data) : setFetchError(true)
        )
        .catch(() => setFetchError(true))
        .finally(() => setLoading(false))
    }
  }, [checkID])

  useEffect(() => {
    if (check.attachment) {
      API.post('/gets3downloadurl?inlineView=true', {
        key: check.attachment,
      }).then((res) => res.status === 200 && setAttachment(res.data))
    }
  }, [check.attachment])

  return (
    <BigModal open={checkID} onClose={onClose}>
      <Stack gap={1}>
        <DetailsBox
          title="Driving Licence Check"
          rows={[
            {
              label: 'Date',
              value: check.date ? moment(check.date).format('Do MMM YYYY') : '',
            },
            { label: 'Issue Number', value: check.licenceIssueNumber },
            {
              label: 'Valid From',
              value: check.validFrom
                ? moment(check.validFrom).format('Do MMM YYYY')
                : '',
            },
            {
              label: 'Valid Until',
              value: check.validTo
                ? moment(check.validTo).format('Do MMM YYYY')
                : '',
            },
            { label: 'Driving Status', value: check.drivingStatus },
            { label: 'Active Points', value: check.activePoints },
            { label: 'Categories', value: check?.categories?.join(', ') },
          ]}
          fullWidthLabels
        />
        <DetailsBox fullWidthLabels title="Endorsements">
          {check?.endorsements?.length > 0 ? (
            <CustomDataGrid
              columns={[
                { field: 'code', headerName: 'Code', minWidth: 100 },
                { field: 'points', headerName: 'Points', minWidth: 100 },
                {
                  field: 'offenceDate',
                  headerName: 'Offence Date',
                  minWidth: 200,
                  renderCell: ({ value }) =>
                    value ? moment(value).format('Do MMM YYYY') : '',
                },
                {
                  field: 'expiryDate',
                  headerName: 'Expiry Date',
                  minWidth: 200,
                  renderCell: ({ value }) =>
                    value ? moment(value).format('Do MMM YYYY') : '',
                },
                {
                  field: 'description',
                  headerName: 'Description',
                  minWidth: 300,
                  flex: 1,
                },
              ]}
              rows={check?.endorsements ?? []}
              getRowId={(row) => row.code + row.offenceDate}
              disableRowSelectionOnClick
              slots={{
                toolbar: () => null,
                footer: () => null,
              }}
            />
          ) : (
            <Alert severity="success">No Endorsements</Alert>
          )}
        </DetailsBox>
        {check.riskAssessment && (
          <DetailsBox
            fullWidthLabels
            title="Risk Assessment"
            rows={[
              {
                label: 'Date',
                value: check?.riskAssessment?.date
                  ? moment(check.riskAssessment.date).format('Do MMM YYYY')
                  : '',
              },
              {
                label: 'Completed By',
                value: check?.riskAssessment?.completedBy
                  ? check.riskAssessment.completedBy.firstName +
                    ' ' +
                    check.riskAssessment.completedBy.lastName
                  : '',
              },
              { label: 'Note', value: check?.riskAssessment?.note ?? '' },
            ]}
          />
        )}
        {attachment && (
          <DetailsBox title="Attachment">
            <Box component="img" src={attachment} maxHeight={200} />
          </DetailsBox>
        )}
        <Button
          onClick={() => onClose()}
          variant="contained"
          fullWidth
          color="anRed"
        >
          Close
        </Button>
      </Stack>
    </BigModal>
  )
}

export default SingleDrivingLicenceCheck
